import React from 'react';
import { Button } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';

interface ISwiperIconType {
  type: 'prev' | 'next';
  disabled: boolean;
  handleIconClick: Function;
}

export default function SwiperIcon(props: ISwiperIconType) {
  const { type = 'next', handleIconClick, disabled } = props;

  return (
    <Button
      disabled={disabled}
      type="link"
      className="dbi-swiper-icon-wrap"
      // style={{ textAlign: type === 'next' ? 'right' : 'left' }}
      style={{ justifyContent: type === 'next' ? 'flex-end' : 'flex-start' }}
    >
      <div
        className={`dbi-swiper-icon ${disabled ? 'disabled' : ''}`}
        onClick={() => handleIconClick(type)}
      >
        <SvgIcon
          type={type === 'next' ? 'point-right' : 'point-left'}
          className="dbi-swiper-arrow"
        />
      </div>
    </Button>
  );
}
